export default `return mat2(cos(r), sin(r), -sin(r), cos(r));
  }
  float de(vec3 p){
    float d, a;
    d=a=1.;
    for(int j=0;j++<9;)
      p.xz=abs(p.xz)*rotate2D(PI/4.),
      d=min(d,max(length(p.zx)-.3,p.y-.4)/a),
      p.yx*=rotate2D(.5),
      p.y-=3.,
      p*=1.8,
      a*=1.8;
    return d;
  }`